import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function norm(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    scope:['OWNED','WATCHLIST','RESEARCH'].includes(x.scope)?x.scope:'RESEARCH',
    urgency:Number.isFinite(x.urgency)?Math.max(0,x.urgency):0,
    readiness:x.readiness||'UNKNOWN',
    nextTask:x.nextTask||null,
    taskMinutes:Number.isFinite(x.taskMinutes)?Math.max(5,Math.round(x.taskMinutes)):15,
    evidenceGapCount:Number.isFinite(x.evidenceGapCount)?Math.max(0,Math.floor(x.evidenceGapCount)):0,
    invalidatedCount:Number.isFinite(x.invalidatedCount)?Math.max(0,Math.floor(x.invalidatedCount)):0,
    eventWithin24h:x.eventWithin24h===true
  });
}

function priority(x){
  const n=norm(x);
  let p=n.urgency;
  if(n.scope==='OWNED') p+=30;
  else if(n.scope==='WATCHLIST') p+=10;
  if(n.readiness==='BLOCKED') p+=25;
  if(n.invalidatedCount) p+=Math.min(20,n.invalidatedCount*8);
  if(n.evidenceGapCount) p+=Math.min(15,n.evidenceGapCount*4);
  if(n.eventWithin24h) p+=15;
  return p;
}

function allocate(items,minutes){
  let left=Number.isFinite(minutes)?Math.max(0,Math.round(minutes)):60;
  const rows=(Array.isArray(items)?items:[]).map(norm).sort((a,b)=>priority(b)-priority(a)||(a.symbol||'').localeCompare(b.symbol||''));
  const selected=[],deferred=[];
  for(const r of rows){
    if(r.taskMinutes<=left){
      selected.push(Object.freeze({...r,priority:priority(r)}));
      left-=r.taskMinutes;
    } else {
      deferred.push(Object.freeze({...r,priority:priority(r),reason:'TIME_BUDGET'}));
    }
  }
  return Object.freeze({
    selected:Object.freeze(selected),
    deferred:Object.freeze(deferred),
    minutesBudget:Number.isFinite(minutes)?Math.max(0,Math.round(minutes)):60,
    minutesUsed:(Number.isFinite(minutes)?Math.max(0,Math.round(minutes)):60)-left,
    minutesRemaining:left,
    tradeSignal:false,
    capitalPermission:false,
    universalScore:null
  });
}

function nextBest(items,minutes){
  const a=allocate(items,minutes);
  return a.selected.length?a.selected[0]:null;
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const owned={symbol:'AAA',scope:'OWNED',urgency:70,readiness:'BLOCKED',nextTask:'Verify demand',taskMinutes:20,evidenceGapCount:2,invalidatedCount:1};
  const watch={symbol:'BBB',scope:'WATCHLIST',urgency:70,readiness:'REVIEW',nextTask:'Check valuation',taskMinutes:20};
  const research={symbol:'CCC',scope:'RESEARCH',urgency:40,taskMinutes:30};
  ok('owned priority exceeds equal urgency watchlist',priority(owned)>priority(watch));
  ok('blocked readiness raises priority',priority({...owned,readiness:'REVIEW'})<priority(owned));
  ok('invalidations raise priority',priority({...owned,invalidatedCount:0})<priority(owned));
  ok('evidence gaps raise priority',priority({...owned,evidenceGapCount:0})<priority(owned));
  ok('near event raises priority',priority({...watch,eventWithin24h:true})>priority(watch));

  let a=allocate([watch,owned,research],40);
  ok('highest priority task selected first',a.selected[0].symbol==='AAA');
  ok('budget is respected',a.minutesUsed<=40);
  ok('two 20-minute tasks fit 40-minute budget',a.selected.length===2);
  ok('oversized lower priority task deferred',a.deferred.some(x=>x.symbol==='CCC'));
  ok('remaining minutes calculated',a.minutesRemaining===0);
  ok('nextBest returns top selected task',nextBest([watch,owned],20).symbol==='AAA');

  a=allocate([owned],10);
  ok('task larger than budget is deferred',a.selected.length===0&&a.deferred.length===1);
  ok('no trade signal',a.tradeSignal===false);
  ok('no capital permission',a.capitalPermission===false);
  ok('no universal score',a.universalScore===null);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,norm,priority,allocate,nextBest,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestResearchPriorityBudgetEngine=Object.freeze(API);
})(engineContext);